/**
 * Brand SVG primitives - use currentColor so they inherit theme/text color.
 * Two pieces:
 *   - <LogoMark/>      square icon (scales + AI spark)
 *   - <LogoWordmark/>  the "lexaipro" lockup (mark + text)
 */

export function LogoMark({
  className,
  title = "lexaipro",
}: {
  className?: string;
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      className={className}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      {/* AI spark above the beam */}
      <path d="M32 6 l2.4 5.2 L40 13.6 l-5.6 2.4 L32 21.2 l-2.4-5.2 L24 13.6 l5.6-2.4 Z" />
      {/* Vertical column */}
      <rect x="30.5" y="16" width="3" height="34" rx="1.2" />
      {/* Beam */}
      <rect x="12" y="22.5" width="40" height="3" rx="1.2" />
      {/* Left pan (filled triangle + base) */}
      <path d="M16 26 L8 40 H24 Z" />
      <rect x="7" y="40" width="18" height="2.4" rx="1" />
      {/* Right pan */}
      <path d="M48 26 L40 40 H56 Z" />
      <rect x="39" y="40" width="18" height="2.4" rx="1" />
      {/* Base */}
      <rect x="22" y="50" width="20" height="3" rx="1.2" />
      <rect x="18" y="53" width="28" height="3" rx="1.2" />
    </svg>
  );
}

export function LogoWordmark({
  className,
  title = "lexaipro",
}: {
  className?: string;
  title?: string;
}) {
  // Single SVG so the mark + text scale together with `height`.
  return (
    <svg
      viewBox="0 0 222 64"
      role="img"
      aria-label={title}
      className={className}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      {/* Mark (same paths as LogoMark) */}
      <g>
        <path d="M32 6 l2.4 5.2 L40 13.6 l-5.6 2.4 L32 21.2 l-2.4-5.2 L24 13.6 l5.6-2.4 Z" />
        <rect x="30.5" y="16" width="3" height="34" rx="1.2" />
        <rect x="12" y="22.5" width="40" height="3" rx="1.2" />
        <path d="M16 26 L8 40 H24 Z" />
        <rect x="7" y="40" width="18" height="2.4" rx="1" />
        <path d="M48 26 L40 40 H56 Z" />
        <rect x="39" y="40" width="18" height="2.4" rx="1" />
        <rect x="22" y="50" width="20" height="3" rx="1.2" />
        <rect x="18" y="53" width="28" height="3" rx="1.2" />
      </g>
      {/* Wordmark "lexaipro" - rendered as text so it inherits font + color */}
      <text
        x="74"
        y="44"
        fontFamily='"Inter Tight", Inter, -apple-system, "SF Pro Display", system-ui, sans-serif'
        fontSize="34"
        fontWeight="700"
        letterSpacing="-1.4"
      >
        lexaipro
      </text>
    </svg>
  );
}
